export default __webpack_public_path__ + "d2e36f190b8942d97b756c6fa45c3ec9.png";